import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatToolbarModule } from "@angular/material/toolbar";
import { Router, RouterLink, RouterOutlet } from "@angular/router";
import { Subscription } from "rxjs";
import { AuthService } from "./services/auth.service";
import { NGIVAAPService } from "./services/ivaap.service";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    RouterLink,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  title = "Uphole Recompletion Opportunity PoC";
  userName: string | undefined = undefined;

  private router$ = Subscription.EMPTY;
  private authService$ = Subscription.EMPTY;

  get isOnWellsPage(): boolean {
    return this.router.url === '/wells' || this.router.url === '/';
  }


  constructor(
    private authService: AuthService,
    private router: Router,
    private ngIvaapService: NGIVAAPService,
  ) {}

  ngOnInitOld() {
    // Initiate authentication when app starts
    this.ngIvaapService.initialize();
    this.ngIvaapService.IVAAPService?.authService
      .login()
      .then((message: any) => {
        console.log("IVAAP logged in successfully:", message);
        this.ngIvaapService.isAuthenticated.set(true);
      
        this.authService.authenticateUser().subscribe({
          next: (isAuthenticated) => {
            console.log("Authentication result:", isAuthenticated);
          },
          error: (err) => {
            console.error("Authentication error:", err);
          },
        });

        this.authService$ = this.authService.currentAuthStatus.subscribe(
          (authStatus) => {
            if (authStatus.userLoggedIn) {
              //this.userName = this.authService.currentUser?.name;
              this.userName = this.authService.currentUser?.username;
              console.log("User logged in:", this.userName);
              if (authStatus.redirectTo) {
                this.router.navigateByUrl(authStatus.redirectTo);
              }
            }
          },
        );
      });
  }
  
  ngOnInit() {
    this.authService.authenticateUser().subscribe({
      next: (isAuthenticated) => {
        console.log("Authentication result:", isAuthenticated);
      },
      error: (err) => {
        console.error("Authentication error:", err);
      },
    });

    this.authService$ = this.authService.currentAuthStatus.subscribe(
      (authStatus) => {
        if (authStatus.userLoggedIn) {
          //this.userName = this.authService.currentUser?.name;
          this.userName = this.authService.currentUser?.username;
          console.log("User logged in:", this.userName);
          if (authStatus.redirectTo) {
            this.router.navigateByUrl(authStatus.redirectTo);
          }
        }
      },
    );
  }


  ngOnDestroy() {
    console.log(
      "app component being destroyed, unsubscribing from auth service",
    );
    this.authService$.unsubscribe();
  }
}
